import React from "react";

/**
 * Placeholder wordmark + glyph. This is intentionally simple — no
 * final logo, icon set or brand photography has been approved yet.
 * Swap the glyph for real brand assets once Stephen signs off on
 * visual identity.
 */
export default function BrandMark({ onClick, href = "/" }) {
  return (
    <a
      className="brand-mark"
      href={href}
      onClick={onClick}
      aria-label="AskMax home"
    >
      <span className="brand-mark__glyph" aria-hidden="true">M</span>
      <span className="brand-mark__word">AskMax</span>
    </a>
  );
}
